import React from "react";

export const GoldRule = ({ label, className = "" }) => {
  if (!label) return <div className={`gold-hairline ${className}`} />;
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <span className="kicker whitespace-nowrap">{label}</span>
      <div className="gold-hairline" />
    </div>
  );
};

export default GoldRule;
